var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-empty-viewer edg-d--flex edg-w--100 edg-flex-jc--center edg-flex-ai--center edg-h--100"},[_vm._v(" "+_vm._s(_vm.$t('viewer.noContent'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }